import { FormControl, styled } from '@mui/material';
import { device } from '../../constants/devices';
import theme from '../../constants/theme';

export const DropDownStyled = styled(FormControl)({
  '.MuiInputBase-root': {
    border: `5px solid ${theme.palette.primary.light}`,
    background: 'rgba(51, 51, 51, 0.20)',
    backdropFilter: 'blur(20px)',
    borderRadius: 'unset',
    maxWidth: '132px',
    color: theme.palette.secondary.main,
    fontWeight: 700,
    height: '64px',
    fontSize: theme.typography.h6.fontSize,
    paddingTop: 0,
    paddingBottom: 0,
    svg: {
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      fontSize: theme.typography.h3.fontSize,
      pointerEvents: 'none',
      position: 'absolute',
      right: '10px',
    },
    '.MuiSelect-select': {
      paddingLeft: '10px',
      paddingRight: '0 !important',
      paddingBottom: '3px',
    },
    '&:before, &:after, &:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'unset',
    },
    '.MuiSelect-select:focus': {
      background: 'unset',
    },
  },
  'li:hover': {
    background: 'unset !important',
  },
  [device.small]: {
    '.MuiInputBase-root': {
      height: '40px',
      fontSize: `${theme.typography.h6.fontSize} !important`,
    },
  },
});
